<template>
    <div :data-component-name="$options.name" :class="(!field.inputClass) ? 'o-grid-12' : field.inputClass"
        v-if="!disabledIDs.includes(field.id)">
        <inputlabel :field="field" />
        <div class="o-form__item">
            <div class="o-select__wrap">
                <select 
                    class="o-select"
                    :class="{ 'readonly': field.inputReadonly === true }"
                    v-on="readOnlyHandlers"
                    type="text"
                    v-model="field.value"
                    :id="'input-' + field.id"
                    :name="field.inputName"
                    :placeholder="field.inputPlaceholder"
                    :required="(field.inputRequired === true) ? 'required' : false"
                    :multiple="(field.inputChoicesMultiple === true) ? 'multiple' : false"
                    :autocomplete="(field.inputAutocomplete && field.inputAutocomplete != '' && field.inputAutocomplete != 'querystring' && field.inputAutocomplete != 'reactivevalue' && field.inputAutocomplete != 'cookie') ? field.inputAutocomplete : false"
                >
                    <option :value="''" disabled selected>{{ placeholder }}</option>

                    <option v-for="(choice, ci) in choices" :key="'cb-' + ci + '-' + field.id"
                        :value="(String(choice.value).trim() != '') ? choice.value : choice.text"
                        v-html="(String(choice.text).trim() != '') ? choice.text : choice.value">
                    </option>
                </select>
                <div class="o-form__validation" style="visibility: visible; opacity: 1;">
                    <span class="o-form__validation__required">
                        {{ _t('Ce champ est obligatoire.') }}
                    </span>
                    <span class="o-form__validation__error">
                        {{ _t('Ce champ est obligatoire.') }}
                    </span>
                    <span class="o-form__validation__error -no-models" style="display: block; margin-top: 5px" v-if="!loading && !choices.length && category">
                        {{ _t('Aucun type d\'entreprise trouvé pour la catégorie sélectionné.') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Input-businesstypes',
    props: {
        field: {
            type: Object,
            default() {
                return {}
            },
        },
        disabledIDs: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            readOnlyHandlers: {
                keydown: this.handleEvent,
                paste: this.handleEvent,
                focus: this.handleEvent,
                mousedown: this.handleEvent,
            },
            searchByVin: true,
            loading: false,
            isValid: true,
            errorMsg: "",
            choices: [],
            category: null,
            previousValue: null,
            eventScope: this.$parent.field.id,
        }
    },
    mounted() {
        this.$root.getSessionInfo()

        if (this.field.value == null) this.field.value = '';
        if (this.field.repeaterIndex) this.eventScope += '-' + this.field.repeaterIndex;

        this.emitter.on(this.eventScope+':businesstypes-set-category', (value) => {
            this.category = value;
        });
    },
    computed: {
        placeholder() {
            let placeholder = this._t('Choisir');

            if (this.field.inputPlaceholder !== null && this.field.inputPlaceholder) placeholder = this.field.inputPlaceholder;
            if (!this.loading && this.choices.length == 0 && this.category) placeholder = this._t('Aucun type d\'entreprise trouvé.');
            if (!this.loading && !this.category) placeholder = this._t('Vous devez choisir une catégorie.');
            if (this.loading) placeholder = this._t('S.V.P. Patientez...');

            return placeholder
        },
    },
    watch: {
        'field.value': function (val, old) {
            this.previousValue = old;
        },
        category: {
            handler: function (val) {
                if (this.category != null && String(this.category).trim() != '') {
                    this.getTypes();
                }
            },
            deep: true
        }
    },
    methods: {

        handleEvent(e) {
            if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
        },

        getTypes() {

            this.loading = true
            this.choices = []

            if (!this.$root.session) {
                this.$root.getSessionInfo().then((session) => {
                    this.getTypes();
                });
                return
            }

            this.field.value = '';
            fetch('/businesstypes/categories/'+this.category, {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Accept': 'application/json',
                    'X-CSRF-Token': this.$root.session.csrfTokenValue,
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
                .then(response => response.json())
                .then(data => {
                    this.choices = [];
                    data.data.forEach((item) => {
                        this.choices.push({
                            value: item.actual_value,
                            text: (item[this.$root.currentlanguage]) ? item[this.$root.currentlanguage] : item['fr-CA']
                        });
                    });
                    if(this.choices.find(c => c.value == this.previousValue)) {
                        this.field.value = this.previousValue;
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    this.errorMsg = error
                })
                .finally(() => {
                    this.loading = false;
                });

        },

    },
}
</script>